import { gql, useQuery } from '@apollo/client';
import {
  OnlineUserStatesQuery,
  OnlineUserStatesQueryVariables,
  UserWithStatus,
} from '../../../graphql/types';

const POLL_INTERVAL = 5000;

export function useOnlineUserStates(userIds: string[]) {
  const { data, client } = useQuery<
    OnlineUserStatesQuery,
    OnlineUserStatesQueryVariables
  >(onlineUserStatesQuery, {
    variables: {
      input: userIds,
    },
    pollInterval: POLL_INTERVAL,
  });

  if (!data) {
    return;
  }
  // write status to cache
  data.onlineUserStates.forEach((onlineUser) => {
    const user = client.readFragment<UserWithStatus>({
      fragment: userWithStatusFragment,
      id: `User:${onlineUser.id}`,
    });
    if (!user) return;
    client.writeFragment<UserWithStatus>({
      fragment: userWithStatusFragment,
      id: `User:${onlineUser.id}`,
      data: { ...user, onlineStatus: onlineUser.status },
    });
  });
}

const onlineUserStatesQuery = gql`
  query OnlineUserStatesQuery($input: [ID!]!) {
    onlineUserStates(userIds: $input) {
      ...OnlineUserState
    }
  }
  fragment OnlineUserState on OnlineUserState {
    id
    status
  }
`;

const userWithStatusFragment = gql`
  fragment UserWithStatus on User {
    id
    onlineStatus
  }
`;
